import initNavbar from "./scripts/navbar";

initNavbar();

function trackAnalyticsEvent(eventName, params = {}) {
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: eventName, ...params });
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

// Scroll reveal animations using IntersectionObserver
const revealElements = document.querySelectorAll(
  ".metric-card, .service-card, .case-study-card, .all-project-card, .tech-group, .blog-preview-card, .contact-wrapper"
);

if (revealElements.length) {
  // Add initial hidden state
  revealElements.forEach((el) => {
    el.style.opacity = "0";
    el.style.transform = "translateY(24px)";
    el.style.transition = "opacity 0.5s ease, transform 0.5s ease";
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1";
          entry.target.style.transform = "translateY(0)";
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
  );

  revealElements.forEach((el, i) => {
    el.style.transitionDelay = `${(i % 4) * 0.08}s`;
    observer.observe(el);
  });
}

document.querySelectorAll(".cta-btn").forEach((button) => {
  button.addEventListener("click", () => {
    const label = (button.textContent || "").trim().toLowerCase().replace(/\s+/g, "_");
    const href = button.getAttribute("href") || "";
    trackAnalyticsEvent("cta_click", {
      cta_label: label,
      cta_href: href,
      page_path: window.location.pathname,
    });
  });
});
